import { render, staticRenderFns } from "./LinkedControlItem.vue?vue&type=template&id=3fc4cd48"
import script from "./LinkedControlItem.vue?vue&type=script&lang=js"
export * from "./LinkedControlItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports